import { HttpStatus } from '@/api/HttpStatus';
import { ResponseError } from '@/gen/api';

export { ResponseError };

export const isUnprocessableEntityError = (error: unknown): boolean =>
  error instanceof ResponseError && error.response.status === HttpStatus.UnprocessableEntity;

interface ErrorResponseBody {
  error?: string;
  message?: string;
}

const readErrorResponse = async (error: ResponseError): Promise<string | undefined> => {
  try {
    const body = (await error.response.json()) as ErrorResponseBody;
    if (typeof body?.error === 'string' && body.error) return body.error;
    if (typeof body?.message === 'string' && body.message) return body.message;
    return undefined;
  } catch {
    return undefined;
  }
};

export const getApiErrorMessage = async (
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
): Promise<string> => {
  if (error instanceof ResponseError) {
    const message = await readErrorResponse(error);
    if (message) return message;
  }

  if (error instanceof Error && error.message) return error.message;

  return fallback;
};
